import wretch from 'wretch';

import { CoreRestErrorHandler } from '../coreCommon/common/rest/CoreRestErrorHandler';
import { CoreRestService } from '../coreCommon/common/rest/CoreRestService';
import { ILearningConfig } from '../../application/config/learning/ILearningConfig';
import { LearningEnvConfigManager } from '../../application/config/learning/LearningEnvConfigManager';
import { ILearningReportService } from './ILearningReportService';
import { IGetUserLearningDataByProjectArg, IGetUserLearningDataByProjectRes } from './interface/IGetUserLearningDataByProject';
import { ILearningMetricsModel } from './interface/ILearningMetricsModel';
import { ILearningProjectRatingModel } from './interface/ILearningProjectRatingModel';
import { ILearningUserDetailModel } from './interface/ILearningUserDetailModel';
import { ILearningUserRatingModel } from './interface/ILearningUserRatingModel';
import { IProjectLearningReportArg } from './interface/IProjectLearningReportArg';
import { IProjectLearningReportModel } from './interface/IProjectLearningReportModel';
import {
  ILearningMetricsSnapshotModel,
  ISnapshotHistoryArg,
  ICreateSnapshotResult,
} from './interface/ILearningMetricsSnapshotModel';
import {
  ILearningProjectMetricsSnapshotModel,
  IProjectSnapshotHistoryArg,
} from './interface/ILearningProjectMetricsSnapshotModel';
import {
  ILearningUserMetricsSnapshotModel,
  IUserSnapshotHistoryArg,
} from './interface/ILearningUserMetricsSnapshotModel';

wretch().errorType('json');

export class RestLearningReportService  extends CoreRestService implements ILearningReportService {
  constructor(
    protected config: ILearningConfig = LearningEnvConfigManager.getConfig(),
    protected errorHandler = new CoreRestErrorHandler(),
  ) {
    super();
  }
  getProjectStat(arg: IProjectLearningReportArg = {}): Promise<IProjectLearningReportModel[]> {
    return super.post(`${this.getEndpoint()}/learning/getProjectStat`, arg)
  }

  getMetrics(arg: IProjectLearningReportArg = {}): Promise<ILearningMetricsModel> {
    return super.post(`${this.getEndpoint()}/learning/metrics`, arg);
  }

  getProjectRatings(arg: IProjectLearningReportArg = {}): Promise<ILearningProjectRatingModel[]> {
    return super.post(`${this.getEndpoint()}/learning/ratings/projects`, arg);
  }

  getUserRatings(arg: IProjectLearningReportArg = {}): Promise<ILearningUserRatingModel[]> {
    return super.post(`${this.getEndpoint()}/learning/ratings/users`, arg);
  }

  getUserDetail(userId: string): Promise<ILearningUserDetailModel> {
    return super.get(`${this.getEndpoint()}/learning/ratings/user/${userId}`);
  }

  getEndpoint(): string {
    const url = this.config.url.api.learning;
    return `${url}/report`;
  }

  async post(url: string, data: any): Promise<any> {
    return this.request().url(url).post(data);
  }

  async getUserLearningDataByProject({
    type,
    reportArg = {},
  }: IGetUserLearningDataByProjectArg): Promise<IGetUserLearningDataByProjectRes> {
    const url = `${this.getEndpoint()}/learning/getUserLearningDataByProject/${type}`;

    const doc = await this.request().url(url).post(reportArg);

    const blobDoc = await doc.blob();

    return blobDoc;
  }

  async getUserLearningDataByEmployee({ type, reportArg = {} }: IGetUserLearningDataByProjectArg): Promise<Blob> {
    return this.request().url(`${this.getEndpoint()}/learning/getUserLearningDataByEmployee/${type}`).post(reportArg).blob();
  }

  createSnapshot(): Promise<ICreateSnapshotResult> {
    return super.post(`${this.getEndpoint()}/learning/snapshot/create`, {});
  }

  getMetricsHistory(arg: ISnapshotHistoryArg = {}): Promise<ILearningMetricsSnapshotModel[]> {
    return super.post(`${this.getEndpoint()}/learning/snapshot/metrics`, arg);
  }

  getProjectMetricsHistory(arg: IProjectSnapshotHistoryArg = {}): Promise<ILearningProjectMetricsSnapshotModel[]> {
    return super.post(`${this.getEndpoint()}/learning/snapshot/projects`, arg);
  }

  getUserMetricsHistory(arg: IUserSnapshotHistoryArg): Promise<ILearningUserMetricsSnapshotModel[]> {
    return super.post(`${this.getEndpoint()}/learning/snapshot/users`, arg);
  }
}
